export default "__VITE_ASSET__441a8b32__"